export default __webpack_public_path__ + "static/media/clock.47383aab.svg";